import rootPath, { RouteProps as ParentRouteProps } from "../routes-path";

export default rootPath + "/casto-kladene-dotazy/:labelId?";

export interface RouteProps extends ParentRouteProps {
    labelId?: string;
}
